import { formatBrasilia, type ApiDateValue } from '@/lib/brasiliaDate';

/**
 * Textos das ações de troca de plano bloqueadas. A REGRA (se está bloqueado e
 * até quando) vem pronta do backend em `annual_lock_until`; aqui só se monta a
 * frase exibida ao assinante.
 */
const dataDaVigencia = (lockUntil: ApiDateValue): string => formatBrasilia(lockUntil, 'dd/MM/yyyy');

export const annualLockToMonthlyMessage = (lockUntil: ApiDateValue): string =>
  `Não é possível migrar para o plano mensal agora. Seu plano anual está vigente até ${dataDaVigencia(lockUntil)} e, após essa data, você poderá alterar a periodicidade normalmente.`;

export const annualLockToPlanMessage = (planName: string, lockUntil: ApiDateValue): string =>
  `Não é possível migrar para o ${planName} agora. Seu plano anual está vigente até ${dataDaVigencia(lockUntil)} e, após essa data, você poderá trocar de plano normalmente.`;

export const PENDING_CHANGE_BLOCKS_CYCLE_MESSAGE =
  'Você tem uma troca de plano aguardando pagamento. Conclua o pagamento ou cancele a troca para alterar a periodicidade.';

/** Nome do plano sempre com "Plano" na frente ("Essencial" → "Plano Essencial"),
 * sem repetir quando o nome já começa assim. `null` quando não há nome. */
export const planDisplayName = (name: string | null | undefined): string | null => {
  const nome = (name ?? '').trim();
  if (!nome) return null;
  return /^plano\s/i.test(nome) ? nome : `Plano ${nome}`;
};

/** Modal da troca aguardando pagamento: a cobrança aberta do plano pedido. */
export const pendingPlanChangeChargeLine = (targetPlan: string | null | undefined, annual: boolean): string =>
  `Há uma cobrança aberta para o ${planDisplayName(targetPlan) ?? 'novo plano'}${annual ? ' (anual)' : ''}.`;

/** Modal da troca aguardando pagamento: o que acontece com o plano pedido e o atual (chamado 7112). */
export const pendingPlanChangeDescription = (
  targetPlan: string | null | undefined,
  currentPlan: string | null | undefined,
): string => {
  const alvo = planDisplayName(targetPlan);
  const atual = planDisplayName(currentPlan);
  return (
    `${alvo ? `O ${alvo}` : 'O novo plano'} será liberado assim que o pagamento for confirmado. ` +
    `Enquanto isso, você continuará usando ${atual ? `o ${atual}` : 'o seu plano atual'} normalmente. ` +
    'Se a fatura vencer sem pagamento, a troca será cancelada automaticamente.'
  );
};
